import '../styles/PlayPresentationButton.css';

interface PlayPresentationButtonProps {
    handlePlay: any;
    isPlaying?: boolean;
    isOnFirstSlide?: boolean;
}

const PlayPresentationButton= ({handlePlay, isPlaying = false, isOnFirstSlide = false}: PlayPresentationButtonProps) => {
    // Button should only be shown when:
    // 1. The first slide (slideIndex === 0) is currently active AND
    // 2. Playback has started (isPlaying === true)
    const shouldShow = isOnFirstSlide && isPlaying;
    
    return (
        shouldShow ?
        <div 
            className="play-presentation-menu-container" 
            onClick={() => {
                handlePlay();
            }}
            style={{ cursor: 'pointer', opacity: 1 }}
        >
        </div>
            : null
    );
};

export default PlayPresentationButton;